'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _TextInputInput = require('./TextInputInput');

var _TextInputInput2 = _interopRequireDefault(_TextInputInput);

var _TextInputLabel = require('./TextInputLabel');

var _TextInputLabel2 = _interopRequireDefault(_TextInputLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// `<input/>` and its `<label/>`.
function TextInputComponent(props, ref) {
	var id = props.id,
	    value = props.value,
	    required = props.required,
	    floatingLabel = props.floatingLabel,
	    label = props.label,
	    placeholder = props.placeholder,
	    multiline = props.multiline,
	    error = props.error,
	    indicateInvalid = props.indicateInvalid,
	    containerRef = props.containerRef;

	var Icon = props.icon,
	    className = props.className,
	    children = props.children,
	    rest = _objectWithoutProperties(props, ['icon', 'className', 'children']);

	return _react2.default.createElement(
		'div',
		{
			ref: containerRef,
			className: (0, _classnames2.default)('rrui__input', {
				'rrui__input--multiline': multiline
			}) },
		Icon && _react2.default.createElement(Icon, { className: 'rrui__input-field__icon' }),
		_react2.default.createElement(_TextInputInput2.default, _extends({}, rest, {
			ref: ref,
			className: (0, _classnames2.default)(className, {
				'rrui__input-field--with-icon': Icon
			}) })),
		label && _react2.default.createElement(
			_TextInputLabel2.default,
			{
				'aria-hidden': true,
				inputId: id,
				value: value,
				required: required,
				invalid: indicateInvalid && error,
				floats: floatingLabel && !placeholder },
			label
		),
		children
	);
}

TextInputComponent = _react2.default.forwardRef(TextInputComponent);

TextInputComponent.propTypes = {
	// Set to `true` to mark the field as required.
	required: _propTypes2.default.bool.isRequired,

	// Indicates that the input is invalid.
	error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),

	// Labels float by default.
	floatingLabel: _propTypes2.default.bool.isRequired,

	// `<input/>` icon.
	icon: _propTypes2.default.func
};

TextInputComponent.defaultProps = {
	// Set to `true` to mark the field as required.
	required: false,

	// Labels float by default.
	floatingLabel: true
};

exports.default = TextInputComponent;
//# sourceMappingURL=TextInputComponent.js.map